import queueTask from 'post-task';
import { dispatchExternalEvent, isBrowser } from '@sbt-web/utils';

export function dispatchAsyncEvent(eventName: string): void {
  if (isBrowser()) {
    queueTask(() => dispatchExternalEvent(eventName), 'background');
  }
}
